import api from "./api"

export function fnFormList(nBoardId) {
    const response = api.get(`/op-panel/block-forms/${nBoardId}`)
    return response
}


export function fnCreateNewForm(oData) {
    const response = api.post(`/op-panel/block-forms`, oData)
    return response
}
export function fnUpdateForm(nFormId, oData) {
    const response = api.put(`/op-panel/block-forms/${nFormId}`, oData)
    return response
}

export function fnShowTutorialModal() {
    const response = api.get(`/op-panel/tutorials/block-form`)
    return response
}

export function fnHidenTutorialModal() {
    const response = api.put(`/op-panel/tutorials/block-form`)
    return response
}

export function fnShowFormDetails(nFormId) {
    const response = api.get(`/op-panel/block-forms/${nFormId}/details`)
    return response
}
export function fnListFieldsFromForm(nCustomId, nFormId) {
    const response = api.get(`/op-panel/block-forms/${nCustomId}/${nFormId}`)
    return response
}

export function fnCreateActivityByForm(nId, oData) {
    const response = api.post(`operational-panel-activity/${nId}/by-block-form`, oData, { headers: { 'Content-Type': 'multipart/form-data;' } })
    return response
}

export function fnUpdateStatusForm(nFormId, bStatus) {
    const response = api.patch(`/op-panel/block-forms/${nFormId}/is-active`, { isActive: bStatus })
    return response
}

export function fnDeleteForm(nFormId, oParams) {
    const response = api.delete(`/op-panel/block-forms/${nFormId}`, { data: oParams })
    return response
}